// extracted by mini-css-extract-plugin
module.exports = {"copyBtn":"model-toolbar_copyBtn___iiYm"};